export default "__VITE_ASSET__ouveWGnv__"